interface WindowWithNativeProps extends Window {
  isNativeApp?: any
  ReactNativeWebView?: any
}

const sendGeolocationPermissionsEventToReactNative = () => {
  const windowsWithNativeProps: WindowWithNativeProps = window

  if (windowsWithNativeProps.ReactNativeWebView) {
    windowsWithNativeProps.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'geolocationPermissions',
      }),
    )
  }
}

export const getBrowserPosition = async () => {
  const geolocation = navigator.geolocation

  sendGeolocationPermissionsEventToReactNative()

  const location = new Promise<{
    coords: { latitude: number; longitude: number }
  }>((resolve, reject) => {
    if (!geolocation) {
      reject(new Error('Not Supported'))
    }

    setTimeout(() => reject(new Error('Permission denied')), 5000)

    geolocation.getCurrentPosition(
      position => {
        resolve(position)
      },
      () => {
        reject(new Error('Permission denied'))
      },
      { timeout: 5000 },
    )
  })

  return await location
}



// WEBPACK FOOTER //
// ./src/utils/services/geolocationBrowserService.ts